export const validatePostalCode = (value: string): boolean => {
  const hasSpecialCharOrLetter = /[^0-9]/.test(value);

  return !hasSpecialCharOrLetter && value.length === 5;
}
